export const ColorsMTO = {
    Black: {
        code: '#000',
        label: 'Black'
    },
    Red: {
        code: '#F02424',
        label: 'Red'
    },
    Yellow: {
        code: '#EBBF2B',
        label: 'Yellow'
    },
    Green: {
        code: '#418D18',
        label: 'Green'
    },
    White: {
        code: '#FFFFFF',
        label: 'White'
    },
    Orange: { code: '#CB830E', label: 'Orange' },
    Blue: { code: '#355FD3', label: 'Blue' },
    Pink: { code: '#BC3D81', label: 'Pink' },
    LightGrey: { code: '#C0C0C0', label: 'LightGrey' },
    darkPink:{
        code:'#820f4c',
        label:'dark Pink'
    },   
}